// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3Zpn9","input":"style_input__34ja7","form":"style_form__2VK1g","column":"style_column__3pVnf","warning":"style_warning__2H-k5"};